import { createClient } from "@supabase/supabase-js";

// These come from .env (see .env.example). In Lovable, set them under
// Project Settings > Environment Variables as VITE_SUPABASE_URL and
// VITE_SUPABASE_ANON_KEY, pointing at the Supabase project the admin
// dashboard also writes to.
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "https://mbqtdfdhqbpbcfqzdbso.supabase.co";
const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1icXRkZmRocWJwYmNmcXpkYnNvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODIyOTYzOTksImV4cCI6MjA5Nzg3MjM5OX0.TisJJ2ussUatPzP0WTEtgjVFMIIbtRqaW8lUyVJEogw";

// True once real credentials are set. Used only for a console warning —
// the site never crashes because of this, see src/hooks/useSupabaseData.ts.
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured && import.meta.env.DEV) {
  console.warn(
    "[Supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are not set. " +
      "The site will run on the placeholder data in src/mocks/ until these " +
      "are configured (see .env.example and README-ADRIAN.md).",
  );
}

// Placeholder values let the client construct without throwing when env
// vars are missing (e.g. local preview before Adrian finishes setup).
// Every real query will fail against these, which is intentional — the
// fallback logic in useSupabaseData() catches that and serves mock data.
export const supabase = createClient(
  supabaseUrl || "https://placeholder.supabase.co",
  supabaseAnonKey || "placeholder-anon-key",
);
